<p class="body">
  You’ll see this number on a plate or sticker on your {{ vm.productDescription }}. Please enter it here.
</p>

<app-text-search
  name="item_product"
  placeHolder="Start typing to search..."
  [ngModel]="vm.formValue['item_product']"
  (loadingData)="loadingData.emit($event)"
/>

@if (!vm.valid && vm.formSubmitted) {
  <section class="error mt-8">
    <i class="fa-light fa-circle-exclamation"></i>
    <p class="body">{{ vm.errors[0] }}</p>
  </section>
}

<section class="flex-col gap-8">
  <p class="label">Why do we need this?</p>

  <ul class="why-do-we-need-this flex-col gap-8">
    <li class="body">
      <i class="fa-light fa-check mt-4"></i>
      It helps us identify what’s wrong, so we can fix it
    </li>
    <li class="body">
      <i class="fa-light fa-check mt-4"></i>
      It allows us to bring the right parts for your appliance
    </li>
  </ul>
</section>

<section class="panel mb-16" [class.open]="vm.panelExpanded">
  <section class="header">
    <button type="button" class="label flex gap-8 body large" (click)="panelExpanded.set(!vm.panelExpanded)">
      <span> Where to find the number </span>

      <i class="fa-regular" [class.fa-chevron-up]="vm.panelExpanded" [class.fa-chevron-down]="!vm.panelExpanded"></i>
    </button>
  </section>

  <section [appAnimateOpen]="vm.panelExpanded" class="content">
    <section class="flex-col gap-8 full-width mt-8">
      <ul class="where-to-find flex-col gap-8">
        <li class="body">In your appliance’s user manual</li>
        <li class="body">
          On a label on the side of your appliance or inside the door (look for a number called “model” or “mod”)
        </li>
      </ul>

      @if (vm.brandImage) {
        <section class="p-16">
          <img class="max-w-298 block mx-auto" [src]="'assets/images/model-number-diagrams/' + vm.brandImage" alt="" />
        </section>
      }

      <section class="number-is-important p-16 flex-col gap-8">
        <p class="label">
          <i class="fa-light fa-circle-exclamation"></i>
          This number is important
        </p>

        <p class="body">It allows us to:</p>

        <ul class="flex-col gap-8">
          <li class="body">Understand exactly what’s wrong with your appliance</li>
          <li class="body">Bring the right parts on the first visit</li>
        </ul>

        <p class="body">Without the number, your repair will probably take <strong>more than one visit.</strong></p>
      </section>
    </section>
  </section>
</section>
